import React, { useEffect, useState } from 'react'
import { withTranslation } from "react-i18next";
import LoaderImg from "../../../../../../../src/assets/images/icons/ajax-loader.svg"
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../../../../helpers/global_helper";
import { formatPrice } from "../../../../../NumberFormat";

const WinPopup = (props) => {
  const { status, bettype, date, gameId, limitId, period, transId, game } = props;
  const [transectionDetailData, setTransectionDetailsData] = useState([]);
  const [gameCode, setGameCode] = useState('');
  const [totalBuyers, setTotalBuyers] = useState(0);
  const [totalBuyers1, setTotalBuyers1] = useState(0);

  // api for Transection History Detail
  const featchTransectionHistoryDetail = () => {
    let reqData = {
      act: status,
      bettype: bettype,
      date: date,
      game_id: gameId,
      limitid: limitId,
      period: parseInt(period),
      trans_id: transId,

    };
    makeAjax(url.PLAYER_API.getTransaction, reqData, url.PLAYER_MS_EXT).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        if (response.code != "validation_error") {
          showMessage(response);
          return;
        }
        showMessage(response);
        return;
      }

      setTransectionDetailsData(response.data.result);
      setGameCode(response.data.game.game_code)
      // Calculate total buyers
      const total = response.data.result.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.win_amount);
      }, 0);
      setTotalBuyers(total.toFixed(2));

      const total1 = response.data.result.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.total_win);
      }, 0);
      setTotalBuyers1(total1.toFixed(2));

    });
  };


  useEffect(() => {
    featchTransectionHistoryDetail();
  }, []);
  return (
    <>
      {(gameId == 501) ?
        <div className="poupup_detail_table">
          <table className="table_data" border="0">
            <thead>
              <tr>
                <th>{props.t("period")}</th>
                <th>{props.t("Total")}</th>
                <th>{props.t("Mines")}</th>
                <th>{props.t("Mine Tiles")}</th>
                <th>{props.t("Open Tiles")}</th>
                <th>{props.t("Total prize ")}</th>
              </tr>
            </thead>
            <tbody>
              {transectionDetailData.length === 0 ? (
                <tr className="table_data_empty_row">
                  <td colSpan="8">{props.t("data_not_found")}</td>
                </tr>
              ) : (
                transectionDetailData.map((value, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "first_bg" : "second_bg"}
                  >
                    <td>{`${gameCode}-`} {value.round_id_client}</td>
                    <td>{formatPrice(value.total_bet)}</td>
                    <td>{value.mine_count}</td>
                    <td>{value.mine_tiles?.replace(/\[|\]/g, '')}</td>
                    <td>{value.open_tails?.replace(/\[|\]/g, '')}</td>
                    <td>{formatPrice(value.total_win)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className="total_price_div">
            {props.t("total")}: {formatPrice(totalBuyers1)}
          </div>
        </div>
        :
        <div className="poupup_detail_table">
          <table className="table_data" border="0">
            <thead>
              <tr>
                <th>{props.t("period")}</th>
                {game === "Dingdong Sicbo STANDARD" ? (
                  <>
                    <th>{props.t("bet")}</th>
                    <th>{props.t("bet")} 2</th>
                    <th>{props.t("bet")} 3</th>
                  </>
                ) : (
                  <th>{props.t("bet")}</th>
                )}

                <th>{props.t("amount")}</th>
                <th>{props.t("discount")} %</th>
                <th>Kei %</th>
                <th>{props.t("prize")}</th>
                <th>{props.t("total_amount")}</th>
                <th>{props.t("description")}</th>
              </tr>
            </thead>
            <tbody>
              {transectionDetailData.length === 0 ? (
                <tr className="table_data_empty_row ">
                  {game === "Dingdong Sicbo STANDARD" ? (
                    <>
                      <td colSpan="10">{props.t("data_not_found")}</td>
                    </>
                  ) : (
                    <td colSpan="8">{props.t("data_not_found")}</td>
                  )}
                </tr>
              ) : (
                transectionDetailData.map((value, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "first_bg" : "second_bg"}
                  >
                    <td>{`${parseInt(period)}-${gameCode}`}</td>
                    {game === "Dingdong Sicbo STANDARD" ? (
                      <>
                        <td>{value.bet}</td>
                        <td>{value.bet2}</td>
                        <td>{value.bet3}</td>
                      </>
                    ) : (
                      <td>{value.bet}</td>
                    )}
                    <td>{formatPrice(value.amount)}</td>
                    <td>{value.disc}</td>
                    {value.info === "50-50" ? (
                      <>
                        <td>{formatPrice(value.prize)}</td>
                        <td>-</td>
                      </>
                    ) : (
                      <>
                        <td>-</td>
                        <td>{formatPrice(value.prize)}</td>
                      </>
                    )}
                    <td>{Number(value.win_amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                    {(game === "Dingdong Poker Dice STANDARD" || game === "Dingdong Poker Dice NEW") &&
                      (value.name === "1" || value.name === "2") ? (
                      <>
                        <td>
                          {value.name} - {value.info}
                        </td>
                      </>
                    ) : (
                      <td>{value.info}</td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
          <div className="total_price_div">
            {props.t("total")}: {formatPrice(totalBuyers)}
          </div>
        </div>
      }
    </>
  );
}

export default withTranslation()(WinPopup)
